
<span
  class="visible-xs menu-glyphicon"
  [ngClass]="{
    'toggle-icon': showMenubar
  }"
>
  <span
    aria-hidden="true"
    (click)="onOpenCloseMenuClick()"
    role="button"
    aria-label="close"
  >
    <fa-icon class="glyphicon-menu-hamburger" [icon]="faBars"></fa-icon>
  </span>
</span>

<nav
  class="col-md-1 col-lg-1 col-sm-1 col-1 leftnav animation-navbar hide-for-small-menu"
  role="navigation"
  [ngClass]="{
    'show-for-small-menu': showMenubar,
    'hide-for-small-menu': !showMenubar
  }"
  click-outside
  (onClickOutside)="collapseAll2()"
>
  <ul>
    <li
      class="navbar-item"

      *ngFor="let menu of menuList; let currentIndex = index"
    >
      <a (click)="onMainMenuClicked($event, currentIndex)"
        class="menu-{{ menu.name }} {{ menu.src }}"
        [ngClass]="{active:menu.config.highlight}"
      >
        <span
          class="alert-counter1"
          [ngClass]="{ 'low-alert': !isHighAlert }"
          *ngIf="menu.src == 'menu_alert' && alertCount > 0"
          [matBadge]="alertCount"
          matBadgeSize="medium"
          matBadgeColor="warn"
        ></span>
        <div
          class="hl7-sqaure-top"
          *ngIf="
            menu.src == 'menu_alert' && hl7alertCount > 0 && !alertCount > 0
          "
        >
          <div class="hl7-count-txt" id="alert_counter21">
            {{ hl7alertCount }}
          </div>
        </div>
        <div
          class="hl7-sqaure"
          *ngIf="
            menu.src == 'menu_alert' && hl7alertCount > 0 && alertCount > 0
          "
        >
          <div class="hl7-count-txt" id="alert_counter22" title="{{hl7alertCount}} HL7 alert(s)">
            {{ hl7alertCount }}
          </div>
        </div>
        <div
          class="hl7-sqaure-top3"
          *ngIf="
          menu.src == 'menu_alert' && (manufacturerOrderCount>0 && !manufacturerOrderPref)
          "
          [ngClass]="{'hl7-sqaure-top2':alertCount > 0,'hl7-sqaure-top4':(hl7alertCount > 0 && alertCount > 0) || (hl7alertCount > 0 && !alertCount > 0),'hl7-sqaure-top5':alertCount > 0 && (hl7alertCount > 0 && alertCount > 0) || (hl7alertCount > 0 && !alertCount > 0),'hl7-sqaure-top6':(alertCount !> 0 && hl7alertCount !> 0) }"
        >
          <div class="hl7-count-txt" id="alert_counter23" title="{{manufacturerOrderCount}} Reservationalert(s)">
            {{ manufacturerOrderCount }}
          </div>
        </div>
      </a>
      <ul
        *ngIf="menu.config.showSubMenu"
        style="height: 100% !important; width: 200px"
      >
        <!-- <li #stat>{{ status$ | async }}</li> -->
        <li
          class="navbar-submenu-item"
          *ngFor="let subItem of menu.subItems; let currentIndex = index"
        >
          <div>
            <a
              [hidden]="!subItem.hasSubMenuItems"
              (click)="onSubItemClicked(subItem)"
            >
              <span [hidden]="subItem.showSubMenuItems">+</span>
              <span [hidden]="!subItem.showSubMenuItems">-</span>
              {{ subItem.title }}
            </a>
            <a [hidden]="subItem.hasSubMenuItems || (!isDigiradAccount && subItem.name==='digirad-reports') || (subItem.name == 'manufacturer-order-alerts' && manufacturerOrderPref)" (click)="onSubItemClicked(subItem)">
              {{ subItem.title }}
             <!-- <span *ngif="
                  subItem.name == 'manufacturer-order-alerts' && manufacturerOrderPref
                "
              ></span>-->
              <span
                class="sub-alert-counter1"
                [ngClass]="{ 'low-alert': !isHighAlert }"
                *ngIf="subItem.name == 'manage-alerts' && alertCount > 0"
                [matBadge]="alertCount"
                matBadgeSize="medium"
                matBadgeColor="warn"
              ></span>
              <div
                class="sub-hl7-alert-counter1"
                *ngIf="
                  subItem.name == 'hl7-alerts-messages' && hl7alertCount > 0
                "
              >
                <div class="hl7-count-txt" id="alert_counter24" title="{{hl7alertCount}} HL7 alert(s)">
                  {{ hl7alertCount }}
                </div>
              </div>
              <div
                class="sub-hl7-alert-counter1"
                style="float: right;"
                *ngIf="
                  subItem.name == 'manufacturer-order-alerts' && manufacturerOrderCount>0 && !manufacturerOrderPref
                "
              >
                <div class="hl7-count-txt" id="alert_counter25" title="{{manufacturerOrderCount}} Reservation alert(s)">
                  {{ manufacturerOrderCount }}
                </div>
              </div>
            </a>
          </div>

          <div class="submenu" [hidden]="!subItem.showSubMenuItems">
            <div
              class="nowrap"
              *ngFor="let subMenuItem of subItem.subMenuItems"
            >
              <a
                (click)="onSubMenuItemClicked(subMenuItem)"
                style="padding: 0px"
                [ngClass]="{disabled:subMenuItem.name === 'manage-po-numbers' &&
                enablePOLink.enablepoflag === 'N'}"
              >
              <span *ngIf="subMenuItem.name != '340B-entity-verification' && subMenuItem.name != 'written-directive'">
                {{ subMenuItem.title }}
              </span>
                <span  *ngIf="subMenuItem.name == '340B-entity-verification' && enable340BVerification">
                  {{ subMenuItem.title }}
                </span>
                <span  *ngIf="subMenuItem.name == 'written-directive' && enableWrittenDirectives">
                  {{ subMenuItem.title }}
                </span>
              </a>
            </div>
          </div>
        </li>
      </ul>
    </li>
  </ul>
</nav>
